

export default function Header(){
    return(
        <h1> header example</h1>
    )
}
